import { api } from "../../../utils";

const search = async (_, payload) => {
    let p = new Promise(async (resolve) => {
        console.log("store.mario.google.search", payload);
        let res = await api.node.cross.mario.google.search(payload);
        resolve(res);
    });

    return p;
};

export default {
    search,
};



// WEBPACK FOOTER //
// src/store/mario/google/actions.js